/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aroma_NameInputs */

const en_aroma_name = /** @type {(inputs: Aroma_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aroma name`)
};

const es_aroma_name = /** @type {(inputs: Aroma_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del aroma`)
};

/**
* | output |
* | --- |
* | "Aroma name" |
*
* @param {Aroma_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const aroma_name = /** @type {((inputs?: Aroma_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aroma_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aroma_name(inputs)
	return es_aroma_name(inputs)
});